<template>
  <div class="regions">
    <h1>Coach Tour Pickup Points</h1>
    <PickupPoints />
  </div>
</template>

<script>
import PickupPoints from '@/components/PointsFields.vue'
export default {
  name: 'points-index',
  components: {
    PickupPoints
  },
}
</script>
